var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.866,
    height: 16.329,
    viewBox: "0 0 18.866 16.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28851",
    "data-name": "Group 28851",
    transform: "translate(-125.567 -41.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65884",
    "data-name": "Path 65884",
    d: "M143.683,54.414V47.1a2.459,2.459,0,0,0-2.459-2.459h-7.657a2.545,2.545,0,0,0-2.546-2.545h-2.116a2.588,2.588,0,0,0-2.588,2.587v9.737a2.5,2.5,0,0,0,2.5,2.5h12.355A2.505,2.505,0,0,0,143.683,54.414Z",
    fill: "none",
    stroke: "#4b74be",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5061",
    "data-name": "Line 5061",
    y2: 6.545,
    transform: "translate(135.005 47.506)",
    fill: "none",
    stroke: "#4b74be",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5062",
    "data-name": "Line 5062",
    x2: 6.528,
    transform: "translate(131.741 50.779)",
    fill: "none",
    stroke: "#4b74be",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsActive);
export default __webpack_public_path__ + "static/media/DocumentsActive.999df404326e1a36a914e3bcffe5587e.svg";
export { ForwardRef as ReactComponent };